import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTracking } from "react-tracking";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";

import SpecialistAlternativeRoutes from "./SpecialistAlternativeRoutes";

const SpecialistAlternativeRoot = () => {
  
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Specialist Alternative",
      page: "Specialist Alternative Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {
       //console.log("dispathc intemedio de tecnologia data", data);
        
        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <SpecialistAlternativeRoutes />
      </Track>
    </div>
  );
};

export default SpecialistAlternativeRoot;
